import React from 'react'

export default class Tv extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="form-group row mt-3 text-left">
                    {this.renderLabel()}
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control" 
                            name="tv"
                            {...this.props}
                            value={this.props.value.tv} />
                    </div>
                </div>
            </React.Fragment>
        )
    }

    renderLabel() {
        if(this.props.tipo == "social") {
            return (
                <label className="col-3 col-md-2">Termo de Verificação:</label>
            )
        } else {
            return (
                <label className="col-3 col-md-2">Termo de Visita:</label>
            )
        }
    }
}